import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { adminRouting } from './admin.routing';

import { AdminComponent } from './admin.component';
import { AdminService } from './services/admin.service';
import { MyAccountModule } from './components/myaccount/my-account.module';
import { ChartsModule } from 'ng2-charts';
import { MyOrganisationModule } from './components/my-organisation/my-organisation.module';
import { TranslateModule } from 'ng2-translate';
import { OrganisationsModule } from './components/organisations/organisations.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    adminRouting,
    RouterModule,
    ChartsModule,
    MyAccountModule,
    MyOrganisationModule,
    OrganisationsModule,
    TranslateModule.forRoot()
  ],
  providers: [AdminService],
  declarations: [AdminComponent]
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin.module.ts